import {
  InspectionsCacheEvents,
  invalidateInspectionsCache,
} from '@monorepo/shared/cacheRegisters/complianceCalendar/inspectionsCacheRegister';
import {
  PushMessageTopic as PMT,
  ServerToClientMessages,
} from 'mapistry-shared';
import { useThrottledOnArgsMessageHandler } from '../webSocket';

const onInspectionCalendarEventsChanged: ServerToClientMessages[PMT.InspectionCalendarEventChanged] =
  ({ projectId }) => {
    invalidateInspectionsCache(InspectionsCacheEvents.UPDATE, {
      projectId,
    });
  };

export function useInspectionCalendarMessageHandlers() {
  useThrottledOnArgsMessageHandler(
    PMT.InspectionCalendarEventChanged,
    onInspectionCalendarEventsChanged,
  );
}
